import React, { memo, ReactNode } from 'react';
import cn from 'clsx';

import {
  CircleCheckSolidIcon,
  CircleXmarkSolidIcon
} from '../../shared/icons/icons';

import styles from './product-availability-icon.scss';

interface ProductAvailabilityIconProps {
  availabilityMessageRank?: number;
  iconAvailable?: ReactNode;
}

function ProductAvailabilityIcon(props: ProductAvailabilityIconProps) {
  const { availabilityMessageRank, iconAvailable } = props;

  return (
    <>
      {Number(availabilityMessageRank) > 5 ? (
        <CircleXmarkSolidIcon
          className={cn(
            styles['icon-unavailable'],
            'product-availability-message__icon'
          )}
        />
      ) : (
        <>
          {iconAvailable ? (
            iconAvailable
          ) : (
            <CircleCheckSolidIcon
              className={cn(
                styles['icon'],
                'product-availability-message__icon'
              )}
            />
          )}
        </>
      )}
    </>
  );
}

export default memo(ProductAvailabilityIcon);
